export default __webpack_public_path__ + "static/media/Boots of the Lector.b618357d.jpg";